import React from 'react'

const Loader = ({ size = 'md', className = '', variant = 'primary' }) => {
    const sizeClasses = {
        sm: 'h-4 w-4 border-2',
        md: 'h-8 w-8 border-2',
        lg: 'h-12 w-12 border-4',
        xl: 'h-16 w-16 border-4'
    }

    const variantClasses = {
        primary: 'border-primary-500 border-t-transparent',
        white: 'border-white border-t-transparent',
        neutral: 'border-white/20 border-t-transparent'
    }

    return (
        <div className={`relative ${className}`}>
            {/* Outer ring */}
            <div
                className={`animate-spin rounded-full ${sizeClasses[size]} ${variantClasses[variant]}`}
            ></div>
        </div>
    )
}

export default Loader
